import React, { PureComponent } from 'react';
import Rebase from 're-base';
import Inner from './Inner';
import ArtThumbnail from './ArtThumbnail';
import ArtworkDetail from './ArtworkDetail';
import './ArtCategory.css';

var base = Rebase.createClass({
  apiKey: "AIzaSyAIpqi8mYkAHxbvSOHCea8izG-62wgibmM",
  authDomain: "georgeotto-8390e.firebaseapp.com",
  databaseURL: "https://georgeotto-8390e.firebaseio.com",
  storageBucket: "georgeotto-8390e.appspot.com",
  messagingSenderId: "410420858322"
});

class ArtCategory extends PureComponent {
	constructor() {
		super();
		this.state = {
			artwork : null,
			activeArtwork : null
		}

	}
	componentDidMount() {
		this.ref = base.bindToState(this.props.params.artCategory, {
			context: this,
	    state: 'artwork',
	    asArray: true,
	    queries: {
	    	orderByChild: 'date'
	    }
		});
	}

	componentWillUnmount(){
	  base.removeBinding(this.ref);
	}

	showSelectedArtwork(details) {
		this.setState({
			activeArtwork: details
		});
	}

	renderArtwork = (item) => {
		return <ArtThumbnail key={item.key} details={item} handleClick={this.showSelectedArtwork.bind(this)}/>
	}

	resetActiveArtwork() {
		this.setState({
			activeArtwork: null
		});
	}

  render() {
  	let media;
  	const { artwork, activeArtwork } = this.state;
  	if (artwork) {
  		media = artwork.map(this.renderArtwork);
  	}

  	if (activeArtwork) {
  		media = <ArtworkDetail artwork={activeArtwork} back={this.resetActiveArtwork.bind(this)}/>;
  	}

    return(
      <Inner title={this.props.params.artCategory} classname="gallery">
          { media }
      </Inner>
    )
  }
}
export default ArtCategory;


// WEBPACK FOOTER //
// ./src/components/ArtCategory.js